export default __webpack_public_path__ + "static/media/FrequencyImg.94774cda.svg";